// Node Module Imports
import React from 'react'

import PropTypes from 'prop-types'
import styled from 'styled-components'

// Style Imports
import { colors, space } from '../../style/design-system'

const Pill = ({
  backgroundColor, children, className, color,
}) => <span className={className}>{children}</span>

export default styled(Pill)`
  background-color: ${(props) => props.backgroundColor};
  border-radius: ${space.a};
  color: ${(props) => props.color};
  padding: ${space.a} ${space.c};
  margin-right: ${space.b};

  a {
    color: ${(props) => props.color};
    &:hover {
      color: ${(props) => props.color};
    }
  }
`

Pill.propTypes = {
  backgroundColor: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  color: PropTypes.string,
}

Pill.defaultProps = {
  backgroundColor: colors.dev.green.h(),
  className: '',
  color: colors.dev.green.a(),
}
